import { PageSharedModule } from './../../../../shared/page-shared/page-shared.module';
import { JumpToModule } from './../../../widgets/jump-to/jump-to.module';
import { InfoHeaderModule } from 'src/app/widgets/info-header/info-header.module';
import { NetworkDeepDiveComponent } from './network-deep-dive.component';
import { EsoService } from './../eso.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDataGridModule, DxChartModule, DxTextAreaModule, DxPopupModule, DxRangeSelectorModule, DxAutocompleteModule, DxDropDownButtonModule, DxPopoverModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { NetworkDeepDiveRoutingModule } from './network-deep-dive-routing.module';
import { EsoNetworkDeepDiveProductComponent } from './eso-network-deep-dive-product/eso-network-deep-dive-product.component';
import { EsoNetworkDeepDiveProductsGroupComponent } from './eso-network-deep-dive-products-group/eso-network-deep-dive-products-group.component';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { NumberBoxComponent } from 'src/app/components/number-box/number-box/number-box.component';

@NgModule({
	declarations: [NetworkDeepDiveComponent, EsoNetworkDeepDiveProductComponent, EsoNetworkDeepDiveProductsGroupComponent],
	imports: [
		CommonModule,
		PageSharedModule,

		NetworkDeepDiveRoutingModule,

		InfoHeaderModule,
		JumpToModule,
		HelpButtonComponent,
		ContainerComponent,
		NumberBoxComponent,

		DevEpressCommonModule,

		DxPopupModule,
		DxPopoverModule,
		DxChartModule,
		DxTextAreaModule,
		DxRangeSelectorModule,
		DxDataGridModule,
		DxAutocompleteModule,
		DxDropDownButtonModule,
	],
	providers: [EsoService]
})
export class NetworkDeepDiveModule { }
